/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
 */
export interface ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  assistantId: string;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate interface.
 */
export function instanceOfConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate(
  value: object,
): value is ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSON(
  json: any,
): ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate {
  return ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped(
    json,
    false,
  );
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreateToJSON(
  value?: ConversationalAgentInferencerCreatePolymorphicConversationalAgentInferencerOpenAIAssistantCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    credential_id: value['credentialId'],
  };
}
